var bookingScripts = function() {

    var changeDateInPanels = function(checkin, checkout) {

        var $panelCheckin = $('#checkin-box');
        var $panelCheckout = $('#checkout-box');

        if ($panelCheckin.length && $panelCheckout.length) {

            $panelCheckin.find('.text', $panelCheckin).text(checkin.format('DD.MM.YYYY'));
            $panelCheckin.find('input[name="checkin"]').attr('value', checkin.format('YYYY-MM-DD'));

            $panelCheckout.find('.text', $panelCheckin).text(checkout.format('DD.MM.YYYY'));
            $panelCheckout.find('input[name="checkout"]').attr('value', checkout.format('YYYY-MM-DD'));

        }

    };

    $(function() {

        $(document).on('checkin-checkout-change', function(e, checkin, checkout) {

            checkin = moment(checkin);
            checkout = moment(checkout);

            changeDateInPanels(checkin, checkout);

        });

        head.load(
            '/bower_components/momentjs/min/moment.min.js',
            function() {

                var lang = $('html').attr('lang');

                if (typeof lang !== 'undefined' && lang.length && lang !== 'en') {
                    var url = '/bower_components/momentjs/locale/' + lang + '.js';
                    head.load(url);
                }

                var mixpickerLangUrl = '/bower_components/mixpicker/dist/locale/' + lang + '.min.js';
                head.load(
                    '/bower_components/mixpicker/dist/mixpicker.min.js',
                    mixpickerLangUrl,
                    function() {

                        $('#checkin-box, #checkout-box').mixpicker({
                            'min': true,
                            'mode': 'modal',
                            'select': false,
                            'onSelect': function(state) {
                                if (state.type === 'select') {
                                    $(document).trigger('checkin-checkout-change',
                                        [state.checkin.format('YYYY-MM-DD'),
                                        state.checkout.format('YYYY-MM-DD')]
                                    );
                                    $('.js-panel-btn').trigger('click');
                                }
                            }
                        });

                        $('.js-open-upper').on('click', function(e) {

                            e.preventDefault();

                            var $this = $(this);

                            var checkinVal = $('input[name="checkin"]').val();
                            var checkoutVal = $('input[name="checkout"]').val();

                            var parameter = $this.attr('data-booking-parameter') ? $this.attr('data-booking-parameter') : false;
                            var value = $this.attr('data-booking-value') ? $this.attr('data-booking-value') : false;

                            if (checkinVal && checkoutVal) {

                                if (parameter && value) {
                                	if(parametr == "OfferId") {
                                    	Booking.OpenSidebar({OfferId: value, checkin: checkinVal, checkout: checkoutVal});
                                	}
                                	else {
                                    	Booking.OpenSidebar({RoomId: value, checkin: checkinVal, checkout: checkoutVal});
                                	}

                                } else {
                                    Booking.Open({checkin: checkinVal, checkout: checkoutVal});
                                }

                            } else {

                                if (parameter && value) {
                                	if(parametr == "OfferId") {
                                    	Booking.OpenSidebar({OfferId: value});
                                	}
                                	else {
                                    	Booking.OpenSidebar({RoomId: value});
                                	}
                                } else {
                                    Booking.Open();
                                }

                            }

                        });

                        $('.js-open-upper-simple').on('click', function(e) {

                            e.preventDefault();

                            Booking.Open();

                        });

                        $('.js-open-vouchers').on('click', function (e) {

                            e.preventDefault();

                            Booking.OpenVouchers();

                        });

                    }
                );
            }
        );

    });

}

module.exports = bookingScripts;
